<template>
  <div>
    <v-row no-gutters>
      <!-- :url="computeURL" 
        :maxFileSizeInMB="(1000*maxSize)"
        :acceptedFileTypes="fileType"
        :useCustomDropzoneOptions="true"
        :autoProcessQueue="false"
        paramName="file"
      
      -->
      <v-col cols="2" sm="2" class="text-center">
        <v-row no-gutters class="pa-1">
          <v-col cols="12" sm="12" class="my-1" v-show="canUpload && !$attrs.disabled">
            <v-btn class="hidden-xs-only" rounded small color="primary" @click="upup">upload</v-btn>
            <v-btn class="hidden-sm-and-up mx-2" fab dark x-small color="primary" @click="upup"><v-icon dark>mdi-upload-outline</v-icon></v-btn>
          </v-col>
          <v-col cols="12" sm="12" v-show="canUpload && !$attrs.disabled">
            <v-btn class="hidden-xs-only" rounded small color="primary" @click="getFiles">reload</v-btn>
            <v-btn class="hidden-sm-and-up mx-2" fab dark x-small color="primary" @click="getFiles"><v-icon dark>loop</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col :cols="canUpload && !$attrs.disabled ? 10 : 12" :sm="canUpload && !$attrs.disabled ? 10 : 12">
        <!-- v-bind:preview-template="template" -->
        <span v-show="!(canUpload && !$attrs.disabled)">
          <v-chip class="mr-1 mt-1" close color="primary" text-color="white" close-icon="loop" @click="getFiles">รายการไฟล์แนบ</v-chip>
        </span>
        <dropzone
          style="width: 100%"
          id="customdropzone"
          v-show="canUpload && !$attrs.disabled"
          ref="myVueDropzone"
          @vdropzone-success="showSuccess"
          @vdropzone-success-multiple="successMulti"
          @vdropzone-sending="sending"
          @vdropzone-error="vdropzone_error"
          @vdropzone-mounted="setUrl()"
          :options="dropzoneOptions"
          :include-styling="true"
        >
        </dropzone>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col v-for="(item, index) in files" :key="item.id" class="text-center" cols="12" sm="6" md="6" lg="4" xl="3">
        <v-chip v-if="item.Type !== 'File folder'" class="mr-1 mt-1" color="green" text-color="white">
          <!-- close
          close-icon="mdi-delete"
          @click:close="deleteFile(item)" -->
          <!-- <v-avatar left class="green darken-4">
            
          </v-avatar> -->
          <v-avatar left class="green darken-4" @click="deleteFile(item)" v-if="!$attrs.disabled">
            <v-icon>mdi-delete</v-icon>
          </v-avatar>
          <div :id="'div_file' + (index + 1)" @click="openLink(item.Link)">{{ item.Name }}</div>
        </v-chip>
      </v-col>
      <!-- <v-col v-for="(item,index) in files" :key="item.id" cols="3" sm="4" md="6"  class="ma-0 pa-0">
        <v-card v-if=" item.Type !== 'File folder' ">
          <v-card-text class="pa-2 text-center" >
            <a :href="item.Link" target="_blank">
            [{{item.Type}}]
            </a>
            <a @click="deleteFile(item)" target="_blank" v-if="canDelete">
            <v-icon left>delete</v-icon>
            </a>
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import Api from '@/services/Api'
import Dropzone from 'vue2-dropzone'

// import bus from '@/components/bus'
// bus.$on('itisoGetFiles', this.GetFiles)
export default {
  name: 'drop_zone',
  // props: ['code', 'list', 'dzName', 'maxSize', 'appName', 'canDelete'],
  props: {
    appName: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    list: {
      default: ''
    },
    dzName: {
      type: String,
      default: 'dz'
    },
    maxSize: {
      type: Number,
      default: 2
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canUpload: {
      type: Boolean,
      default: true
    },
    nameCode: {
      type: String,
      default: ''
    },
    fileType: {
      type: String,
      default: 'image/*,application/pdf,.docx,.xlsx,.pptx'
    }
    // files: {
    //   type: Array,
    //   default: []
    // }
  },
  data() {
    return {
      // uploadURL: 'https://httpbin.org/post',
      serverName: process.env.VUE_APP_SERVER_NAME,
      API_PATH: process.env.VUE_APP_API_PATH,
      uploadURL: process.env.VUE_APP_API_PATH + 'api/Upload3/Upload.asp',
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'File',
      queryString: '',
      temp: [],
      files: [],
      dropzoneOptions: {
        url: process.env.VUE_APP_API_PATH,
        acceptedFiles: this.fileType,
        maxFileSizeInMB: this.maxSize * 1000,
        autoProcessQueue: true,
        paramName: 'file',
        addRemoveLinks: true
      }
    }
  },
  components: {
    Dropzone
  },
  mounted() {
    // this.files = this.fileList
    this.getFiles()
  },
  watch: {
    files: function (val) {
      if (val) {
        this.$nextTick(() => {
          this.$emit('filesChange', val)
        })
      }
    },
    code: function (val) {
      if (val !== '') {
        this.$nextTick(() => {
          this.setUrl()
          this.getFiles()
        })
      }
    },
    list: function (val) {
      if (val !== '') {
        this.$nextTick(() => {
          this.getFiles()
        })
      }
    }
  },
  computed: {
    computeURL() {
      // console.log('this.code', this.code)
      // console.log('this.list', this.list)
      // console.log('this.value', this.value)
      var tempUrl = ''
      if (this.code) {
        // console.log('computeURL', this.uploadURL + '?dropzone=1' + '&id=' + this.code)
        tempUrl = this.uploadURL + '?dropzone=1' + '&id=' + this.code
        if (this.list !== undefined) {
          tempUrl = this.uploadURL + '?dropzone=1' + '&id=' + this.code + '&list=' + this.list
        }
      } else {
        // console.log('computeURL', this.uploadURL + '?dropzone=1')
        tempUrl = this.uploadURL + '?dropzone=1'
      }
      if (this.appName !== undefined) {
        tempUrl += '&app=' + this.appName
      }
      if (this.maxSize !== undefined) {
        tempUrl += '&m=' + this.maxSize
      }
      if (this.nameCode !== undefined) {
        tempUrl += '&nameCode=' + this.nameCode
      }
      // console.log('tempUrl', tempUrl)
      return tempUrl
    }
  },
  methods: {
    openLink(link) {
      window.open(link, '_blank')
    },
    setUrl() {
      console.log('setURL')
      // this.dropzoneOptions.url = this.computeURL
      this.$refs.myVueDropzone.setOption('url', this.computeURL) 
      this.getFiles()
    },
    sending(file, xhr, formData) {
      // console.log('url', this.$refs.myVueDropzone.url)
      // console.log('sending file', file.name)
      // console.log('sending xhr', xhr.responseURL)
      var fn = encodeURI(file.name)
      // formData.append('encFilename', fn)
      formData.append('filename', fn)
    },
    upup() {
      // console.log('this.computeURL', this.$refs.myVueDropzone.options)
      this.$refs.myVueDropzone.options.url = this.computeURL
      this.$refs.myVueDropzone.dropzone.options.url = this.computeURL
      this.dropzoneOptions.url = this.computeURL
      // console.log('this.computeURL', this.$refs.myVueDropzone.options)
      // console.log('getQueuedFiles()', this.$refs.myVueDropzone.getQueuedFiles())
      // this.$refs.myVueDropzone.setOption('url', this.computeURL)
      // this.$refs.myVueDropzone.setOption('maxFilesize', this.maxSize*1000)
      // this.$refs.myVueDropzone.setOption('url', this.computeURL)
      this.$refs.myVueDropzone.processQueue()
      // console.log('getAcceptedFiles', this.$refs.myVueDropzone.getAcceptedFiles())
      // console.log('getUploadingFiles', this.$refs.myVueDropzone.getUploadingFiles())
      this.temp = this.$refs.myVueDropzone.getUploadingFiles()
      if (this.temp.length > 0) {
        this.temp = this.temp[0].xhr
      }
    },
    previewTemplate() {
      return `
                <div class="dz-preview dz-file-preview">
                  <div class="dz-details">
                    <div class="dz-filename"><span data-dz-name></span></div>
                    <div class="dz-size" data-dz-size></div>
                    <img data-dz-thumbnail />
                  </div>
                  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                  <div class="dz-success-mark"><span>✔</span></div>
                  <div class="dz-error-mark"><span>✘</span></div>
                  <div class="dz-error-message"><span data-dz-errormessage></span></div>
                </div>
              `
    },
    successMulti(files, response) {
      // console.log('file', file)
      // console.log('files', files)
      // console.log('response', response)
    },
    vdropzone_error(file) {
      console.log('error', file)
    },
    showSuccess(file) {
      console.log('error', file)
      this.files = this.files.filter(function (ele) {
        return ele.Name !== JSON.parse(file.xhr.responseText)[0].Name
      })
      this.files.push(JSON.parse(file.xhr.responseText)[0])

      this.$refs.myVueDropzone.removeFile(file)
      // console.log('A file was successfully uploaded')
      this.$emit('uploadSuccess', file)
    },
    hasFiles() {
      return this.files.length > 0
    },
    getFiles() {
      // console.log('dropzone getFiles()')
      this.files = []
      // var param // = '&id=' + credentials.id
      // console.log('getFiles ....... param', param)
      // if (this.code === '') return
      // if (this.list === 'undefined' || this.list === undefined) return
      var param = {}
      param.appName = this.appName
      param.ID = this.code
      param.nameCode = this.nameCode
      param.List = this.list
      // console.log('param this.code', this.code)
      // console.log('param', param)
      Api.httpServer()
        .post(this.API_PATH + 'model_tb/default.asp?controller=pfile&action=getfile', param)
        .then((response) => {
          var dataItem = response.data.data
          if (dataItem.length > 0) {
            this.files = dataItem
            // console.log('files', this.files)
          } else {
            this.files = []
          }
          // this.$emit('uploadSuccess', this.files)
        })
    },
    deleteFile(file) {
      if (!confirm('ต้องการลบไฟล์นี้ใช่หรือไม่ ?')) return
      // console.log('delete file', file)
      Api.httpServer()
        .post(this.API_PATH + 'itiso/default.asp?controller=pfile&action=deletefile', file)
        .then((response) => {
          var dataItem = response.data.data
          // console.log('response', response.data.data)
          if (dataItem.deleted) {
            // console.log('before remove files', this.files)
            this.files = this.files.filter(function (ele) {
              return ele.Name !== file.Name
            })
            // console.log('after remove files', this.files)
            this.$emit('uploadSuccess', this.files)
          }
        })
    }
  }
}
</script>
<style scoped>
/* .dropzone .dz-preview .dz-progress {
    opacity: 1;
    z-index: 1000;
    pointer-events: none;
    position: absolute;
    height: 16px;
    left: 50%;
    top: 25%;
    margin-top: -8px;
    width: 80px;
    margin-left: -40px;
    background: hsla(0, 5%, 85%, 0.9);
    border-radius: 8px;
    overflow: hidden;
} */
/* -webkit-transform: scale(1); */
/* .vue-dropzone>.dz-preview .dz-remove:hover {
    padding: 0px !important; 
    font-size: .5rem !important;
}

.vue-dropzone>.dz-preview .dz-details:hover {
    height: 100% !important;
} */
</style>
